import React from 'react'
import BackButton from './BackButton'
import { Stack } from '@mui/material'
import DeleteButton from './DeleteButton'
import SaveButton from './SaveButton'
import { RouteConstants } from '../../navigation/navigation-types'

interface BottomBarProps {
    defaultRoute?: RouteConstants
    deleteText?: string
    deletedEntityName?: string
    onSave?: () => void
    onSaveAndAdd?: () => void
    onDelete?: () => void
    disabled?: boolean
}

const BottomBar: React.FC<BottomBarProps> = ({
    defaultRoute,
    deleteText,
    deletedEntityName,
    onSave,
    onSaveAndAdd,
    onDelete,
    disabled,
}) => {
    return (
        <Stack direction='row' spacing={3} position='fixed' width='100%' bgcolor='white' bottom={0} left={0} p={2} justifyContent='center' boxShadow='0px -1px 10px rgba(0, 0, 0, 0.08)'>
            <BackButton defaultRoute={defaultRoute ?? RouteConstants.home} disabled={disabled} />
            {onSave && <SaveButton variant='save' onClick={onSave} disabled={disabled} />}
            {onSaveAndAdd && <SaveButton variant='saveAndAdd' onClick={onSaveAndAdd} disabled={disabled} />}
            {onDelete && <DeleteButton customButtonText={deleteText} deletedEntityName={deletedEntityName} onClick={onDelete} disabled={disabled} />}
        </Stack>
    )
}

export default BottomBar